var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jp-container" },
    [
      _c(
        "div",
        { staticClass: "main-maximize-exit", on: { click: _vm.exitMaximize } },
        [
          _c("i", { staticClass: "el-icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 1024 1024",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    fill: "currentColor",
                    d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z",
                  },
                }),
              ]
            ),
          ]),
        ]
      ),
      _vm.isTab
        ? _c("tags-view", { style: { "--defaultTheme": _vm.defaultTheme } })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "jp-center overflow",
          style: _vm.isTab ? "top: 34px;" : "top:0px",
        },
        [
          !_vm.isTab
            ? _c(
                "div",
                [
                  _c(
                    "el-breadcrumb",
                    {
                      staticStyle: {
                        "padding-top": "6px",
                        "padding-bottom": "14px",
                      },
                      attrs: { separator: "/" },
                    },
                    [
                      _c(
                        "el-breadcrumb-item",
                        [
                          _c("router-link", { attrs: { to: "/home" } }, [
                            _vm._v("首页"),
                          ]),
                        ],
                        1
                      ),
                      _vm._l(_vm.breadcrumbs, function (breadcrumb, index) {
                        return _c("el-breadcrumb-item", { key: index }, [
                          _vm._v(_vm._s(breadcrumb)),
                        ])
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.$route.meta.type === "iframe"
            ? _c("iframe", {
                attrs: {
                  src: _vm.$route.query.iframeUrl || _vm.$route.meta.iframeUrl,
                  width: "100%",
                  height: "100%",
                  frameborder: "0",
                  scrolling: "yes",
                },
              })
            : _c(
                "keep-alive",
                [
                  _vm.isRouterAlive
                    ? _c("router-view", { key: _vm.$route.fullPath })
                    : _vm._e(),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }